export default __webpack_public_path__ + "static/media/Coronal Jerkin.acdb1271.jpg";